module.exports = __webpack_public_path__ + "static/media/Logo_Penerbit Gorga.85224273.png";